/* tslint:disable */
/* eslint-disable */

import React, { FunctionComponent } from 'react';
import { ViewProps } from 'react-native';
import { Svg, GProps, Path } from 'react-native-svg';
import { getIconColor } from './helper';

interface Props extends GProps, ViewProps {
  size?: number;
  color?: string | string[];
}

let PhotoFail: FunctionComponent<Props> = ({ size, color, ...rest }) => {
  return (
    <Svg viewBox="0 0 1024 1024" width={size} height={size} {...rest}>
      <Path
        d="M398.678016 171.008l-18.944 56.889344H114.233344v398.222336l73.556992-73.556992c20.532224-20.533248 52.795392-22.112256 75.132928-4.739072l5.36576 4.739072 73.499648 73.556992 105.35936-126.464L569.344 683.008l-56.889344 170.667008h-398.22336c-29.159424 0-53.21728-21.97504-56.505344-50.25792L57.344 796.786688V227.897344c0-29.212672 21.97504-53.225472 50.25792-56.507392l6.631424-0.381952h284.444672z m512 0c29.212672 0 53.225472 21.925888 56.507392 50.24768l0.381952 6.641664v568.889344c0 29.159424-21.925888 53.21728-50.24768 56.506368l-6.641664 0.382976H626.233344L683.122688 683.008 510.350336 423.822336l72.818688-87.324672c21.025792-25.273344 58.554368-27.206656 82.05824-5.612544l4.810752 4.98688 240.64 280.747008V227.897344H493.51168l18.944-56.889344h398.22336zM313.372672 284.763136c15.880192 0 30.75072 4.344832 43.48928 11.90912l-15.07328 45.002752 46.368768 69.533696c-14.528512 26.354688-42.58304 44.22144-74.784768 44.22144-47.104 0-85.332992-38.228992-85.332992-85.334016 0-47.104 38.228992-85.332992 85.332992-85.332992z"
        fill={getIconColor(color, 0, '#333333')}
      />
    </Svg>
  );
};

PhotoFail.defaultProps = {
  size: 18,
};

PhotoFail = React.memo ? React.memo(PhotoFail) : PhotoFail;

export default PhotoFail;
